import * as React from 'react'
import {Link as SPALink, NavLink as NavSPALink} from 'react-router-dom'
import {useGlobalStore} from '../../store/hooks/useStore'
import {Box, BoxProps} from '../../vanilla'
import { ICELAND_URL_REGEXP } from '../../utils/constants/validation'
import { ExternalLinkIcon } from '../icons'

// interface IProps extends LinkProps {}

interface IProps extends BoxProps<'a'> {
  _href?: string
  to?: string | null
  href?: string
  useNavLink?: boolean
}

const GLOBAL_TIMESTAMP = Date.now()

const compareDatesInMinutes = (startTime: Date, now: Date) => {
  const timeDifferenceMillis: number = Math.abs(now.getTime() - startTime.getTime())
  const minutesDifference: number = Math.round(timeDifferenceMillis / 60000)
  return minutesDifference
}

const handleClick = (
  event: React.MouseEvent<HTMLElement>,
  href: string,
  customerCacheClearInterval: number,
) => {
  const minutesOnSite = compareDatesInMinutes(new Date(GLOBAL_TIMESTAMP), new Date())
  if (minutesOnSite > customerCacheClearInterval) {
    // Replace with environment variable
    event.preventDefault()
    window.location.href = href
  }
}

function cleanHref(href?: string) {
  if (!href) {
    return href
  }

  return href.replace(ICELAND_URL_REGEXP, '')
}

function isLinkExternal(href: string) {
  if (!href || typeof href !== 'string') {
    return false
  }
  return href.startsWith('http') || href.includes('tel:') || href.includes('mailto:')
}

// interface IProps extends BoxProps<'a'> {}

export const Link = React.forwardRef(
  ({href, to, useNavLink = false, ...props}: IProps, ref: React.Ref<HTMLAnchorElement>) => {
    const {customerCacheClearInterval} = useGlobalStore()
    const _href = cleanHref(to || href) as string
    const isExternal = isLinkExternal(_href)
    const isHTTPLink = href?.startsWith('http')
    const linkOrAnchorSelector = isExternal ? 'a' : useNavLink ? NavSPALink : SPALink
    const newTabOrStayInApp = isExternal
      ? {href: _href, target: '_blank', rel: 'noreferrer noopener'}
      : {to: _href}

    return (
      <Box
        as={linkOrAnchorSelector}
        {...(useNavLink && {exact: true})}
        {...newTabOrStayInApp}
        {...props}
        ref={ref}
        onClick={(event: React.MouseEvent<HTMLAnchorElement>) => {
          handleClick(event, _href, customerCacheClearInterval)
        }}
      >
        {props.children}
        {isExternal && isHTTPLink && <ExternalLinkIcon style={{ display: 'inline-block', marginLeft: '.25rem', verticalAlign: 'text-top', fill: 'currentcolor' }} />}
      </Box>
    )
  },
)

Link.displayName = 'Link'
